/* assets/custom-swiper-init.js (VERSÃO FINAL) */

function initializeAllSwipers() {
  const swiperElements = document.querySelectorAll('[data-swiper]');

  swiperElements.forEach((element) => {
    if (element.swiper) return;

    const options = {
      loop: element.dataset.loop === 'false' ? false : true,
      spaceBetween: parseInt(element.dataset.spaceBetween, 10) || 30,
      slidesPerView: element.dataset.slidesPerView || 1,
    };

    // Lógica ATUALIZADA para a barra de rolagem
    const scrollbarTarget = element.dataset.scrollbar;
    if (scrollbarTarget) {
      // Se o atributo data-scrollbar existir, usa o seletor dele
      options.scrollbar = {
        el: scrollbarTarget,
        draggable: true,
      };
    } else {
      // Senão, procura por uma scrollbar dentro do próprio slider (comportamento antigo)
      const internalScrollbar = element.querySelector('.swiper-scrollbar');
      if (internalScrollbar) {
        options.scrollbar = {
          el: internalScrollbar,
          draggable: true,
        };
      }
    }

    new Swiper(element, options);
  });
}

document.addEventListener('DOMContentLoaded', initializeAllSwipers);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initializeAllSwipers);
  document.addEventListener('shopify:section:reorder', initializeAllSwipers);
}